export enum PriceType {
  TAX_EXCLUSIVE = 'tax_exclusive',
  TAX_INCLUSIVE = 'tax_inclusive',
}
